module.exports = __webpack_public_path__ + "static/media/closed.af926880.svg";